import {StyleRepository} from '@domain/model/Style/StyleRepository';

const GetCustomerId = async (repository: StyleRepository): Promise<string | null> => await repository.getCustomerId();

export {GetCustomerId};
